import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import RendezVousPage from './pages/RendezVousPage';
import ReparationIPhoneSaintChamond from './pages/ReparationIPhoneSaintChamond';
import ReparationSamsungSaintChamond from './pages/ReparationSamsungSaintChamond';
import ChangementEcranIPhoneSaintChamond from './pages/ChangementEcranIPhoneSaintChamond';
import RemplacementBatterieIPhoneSaintChamond from './pages/RemplacementBatterieIPhoneSaintChamond';
import ReparationTelephoneSaintEtienne from './pages/ReparationTelephoneSaintEtienne';
import ReparationConnecteurChargeSaintChamond from './pages/ReparationConnecteurChargeSaintChamond';
import ReparationDegatsEauxSaintChamond from './pages/ReparationDegatsEauxSaintChamond';
import ReparationIPhoneRiveDeGier from './pages/ReparationIPhoneRiveDeGier';
import ReparationIPhoneAndrezieux from './pages/ReparationIPhoneAndrezieux';
import ReparationIPhoneLHorme from './pages/ReparationIPhoneLHorme';
import ReparationIPhoneLaGrandCroix from './pages/ReparationIPhoneLaGrandCroix';
import ReparationIPhoneSorbiers from './pages/ReparationIPhoneSorbiers';
import ReparationIPhoneFirminy from './pages/ReparationIPhoneFirminy';
import BlogPage from './pages/BlogPage';
import BatterieiPhoneSaintChamond from './pages/BatterieiPhoneSaintChamond';
import SamsungEcranNoir from './pages/blog/SamsungEcranNoir';
import ProtegerEcranIPhone from './pages/blog/ProtegerEcranIPhone';
import BatterieQuiGonfle from './pages/blog/BatterieQuiGonfle';
import VillePage from './pages/VillePage';
import ZonesInterventionPage from './pages/ZonesInterventionPage';
import MentionsLegales from './pages/legal/MentionsLegales';
import CGV from './pages/legal/CGV';
import Confidentialite from './pages/legal/Confidentialite';
import MobileBottomBar from './components/MobileBottomBar';
import ScrollToTop from './components/ScrollToTop';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tarifs" element={<Navigate to="/rendez-vous" replace />} />
          <Route path="/rendez-vous" element={<RendezVousPage />} />
          <Route path="/zones-intervention" element={<ZonesInterventionPage />} />
          <Route path="/reparation-telephone/:slug" element={<VillePage />} />
          <Route path="/reparation-iphone-saint-chamond" element={<ReparationIPhoneSaintChamond />} />
          <Route path="/reparation-samsung-saint-chamond" element={<ReparationSamsungSaintChamond />} />
          <Route path="/changement-ecran-iphone-saint-chamond" element={<ChangementEcranIPhoneSaintChamond />} />
          <Route path="/remplacement-batterie-iphone-saint-chamond" element={<RemplacementBatterieIPhoneSaintChamond />} />
          <Route path="/reparation-telephone-saint-etienne" element={<ReparationTelephoneSaintEtienne />} />
          <Route path="/reparation-connecteur-charge-saint-chamond" element={<ReparationConnecteurChargeSaintChamond />} />
          <Route path="/reparation-degats-eaux-saint-chamond" element={<ReparationDegatsEauxSaintChamond />} />
          <Route path="/reparation-iphone-rive-de-gier" element={<ReparationIPhoneRiveDeGier />} />
          <Route path="/reparation-iphone-andrezieux" element={<ReparationIPhoneAndrezieux />} />
          <Route path="/reparation-iphone-lhorme" element={<ReparationIPhoneLHorme />} />
          <Route path="/reparation-iphone-la-grand-croix" element={<ReparationIPhoneLaGrandCroix />} />
          <Route path="/reparation-iphone-sorbiers" element={<ReparationIPhoneSorbiers />} />
          <Route path="/reparation-iphone-firminy" element={<ReparationIPhoneFirminy />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/batterie-iphone-saint-chamond" element={<BatterieiPhoneSaintChamond />} />
          <Route path="/blog/samsung-ecran-noir-que-faire" element={<SamsungEcranNoir />} />
          <Route path="/blog/proteger-ecran-iphone-conseils" element={<ProtegerEcranIPhone />} />
          <Route path="/blog/batterie-telephone-qui-gonfle" element={<BatterieQuiGonfle />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <MobileBottomBar />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
